import { log } from '@domgen/shared/src/utils/log';
import { ModelNumberLookupResponse } from '../../models/services/api/queryModelNumber';
import { get } from './client';

export const queryModelNumber = async (
  modelNumber: string,
  signal?: AbortSignal,
): Promise<ModelNumberLookupResponse> => {
  const brandCode = import.meta.env.VITE_BRAND_CODE;
  try {
    return await get<ModelNumberLookupResponse>(
      `/appliance-lookup?brand=${brandCode}&modelNumber=${modelNumber}`,
      { signal },
    );
  } catch (error: unknown) {
    if (error instanceof Error) {
      log.error({ message: `Error querying model number: ${error.message}` });
    } else {
      log.error({ message: 'Unknown error querying model number' });
    }
    return { appliances: [] };
  }
};
